export const ManageSharedPromptsButtonRefId =
  "manage-shared-prompts-button-ref-id";
